import React from "react"
import classNames from "classnames"
import {FeatureItem} from "../../FeatureItemCard/types"
import {ManagedSolutionsCard} from "../../../containers/ManagedSolutionsCard/ManagedSolutionsCard"
import {FeatureItemCard} from "../../FeatureItemCard/FeatureItemCard"
import {compact} from "lodash"

interface FeaturesCardProps {
	features: FeatureItem[]
	className?: string
	mainDisclaimer?: {
		id: string
		description: string | string[]
	}
}

export function FeaturesCard({features, className, mainDisclaimer}: FeaturesCardProps) {
	const notes = compact(features.map((feature) => feature.note))
	const allNotes = mainDisclaimer ? [mainDisclaimer, ...notes] : notes

	return (
		<ManagedSolutionsCard title="Features" className={classNames("features-card", className)}>
			<div className="columns is-multiline">
				{features.map((feature) => (
					<div key={feature.title} className="column is-one-third">
						<FeatureItemCard {...feature} />
					</div>
				))}
			</div>

			{allNotes.length > 0 && (
				<div className="features-card-notes">
					<ol className="features-card-notes-list">
						{allNotes.map(({id, description}, index) => {
							const descriptionArray = Array.isArray(description) ? description : [description]
							return (
								<li key={`${id}-${index}`} className="features-card-note-item">
									<sup>{id}</sup>{" "}
									<div className="features-card-note-paragraphs">
										{descriptionArray.map((paragraph, paragraphIndex) => (
											<span key={paragraphIndex}>{paragraph}</span>
										))}
									</div>
								</li>
							)
						})}
					</ol>
				</div>
			)}
		</ManagedSolutionsCard>
	)
}
